/**
 * @generated SignedSource<<ce7a71736b3c56ec3f0b785fb96f2920>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HomePanelGroupType = "MEETINGS" | "ONE_ON_ONE" | "OTHER_STREAMS" | "REGULAR" | "TEAMS";
export type tagGroupsQuery$variables = {
  id: string;
};
export type tagGroupsQuery$data = {
  readonly node: {
    readonly homePanelGroup?: {
      readonly id: string;
    } | null;
    readonly id?: string;
  } | null;
  readonly viewer: {
    readonly homePanelGroups: ReadonlyArray<{
      readonly emojiName: string | null;
      readonly id: string;
      readonly name: string;
      readonly type: HomePanelGroupType;
    } | null> | null;
  };
};
export type tagGroupsQuery = {
  response: tagGroupsQuery$data;
  variables: tagGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroup",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroups",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emojiName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tagGroupsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "Tag",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tagGroupsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Tag",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5193e8fa6bb222ed4add405e3d333186",
    "id": null,
    "metadata": {},
    "name": "tagGroupsQuery",
    "operationKind": "query",
    "text": "query tagGroupsQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Tag {\n      id\n      homePanelGroup {\n        id\n      }\n    }\n    id\n  }\n  viewer {\n    homePanelGroups {\n      id\n      type\n      name\n      emojiName\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5359574d7e2547ced1316f62cd597f6";

export default node;
